class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    // ここでは DOM を触らない
    this._onFocusOut = this.onFocusOut.bind(this);
    this._onToggle = this.onToggle.bind(this);
  }

  connectedCallback() {
    // 子が確実に揃ってから初期化
    // もし SSR/遅延装飾で心配なら rAF でさらに一拍置いてもOK
    this._init();
  }

  disconnectedCallback() {
    // 片付け（あれば）
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.removeEventListener('focusout', this._onFocusOut);
      this.mainDetailsToggle.removeEventListener('toggle', this._onToggle);
    }
  }

  _init() {
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) {
      console.warn('[DetailsDisclosure] <details> が見つかりません', this);
      return;
    }

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) {
      console.warn('[DetailsDisclosure] <summary> が見つかりません', this);
      return;
    }

    this.content = summary.nextElementSibling;
    if (!this.content) {
      console.warn('[DetailsDisclosure] コンテンツ要素が見つかりません', this);
    }

    this.mainDetailsToggle.addEventListener('focusout', this._onFocusOut);
    this.mainDetailsToggle.addEventListener('toggle', this._onToggle);
  }

  onFocusOut() {
    // フォーカスが外れたら閉じる
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;

    // 初回のみキャッシュ
    if (!this.animations) {
      // 対象に CSS アニメーション/WAAPI が紐づいていないと空配列になります
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// -------------------------

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    // ここでは参照だけ（DOM クエリは OK）
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    // 親の _init がイベントを束ねるので、このメソッドはそのまま上書きで呼ばれます
    if (!this.header || !this.mainDetailsToggle) return;

    this.header.preventHide = this.mainDetailsToggle.open === true;

    // すでに設定済みなら何もしない
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    const bottom = Math.floor(this.header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${bottom}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
